import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewsModule } from './views/views.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ViewsModule
  ]
})
export class FeaturesModule { }
